import { createFileRoute, useSearch } from '@tanstack/react-router';
import { DocumentForm } from '@/pages/documents/form';
import { PROTECTED, ORDERS } from '@/lib/constants/routes';
import { createSheetRouteOptions } from '@/components/molecules/sheet-view-loader/route-helpers';

const RETURN_URL = `${PROTECTED}${ORDERS}`;

export const Route = createFileRoute('/protected/_layout/orders/_layout/$id')({
  ...createSheetRouteOptions(RETURN_URL),
  component: EditOrderModal,
});

function EditOrderModal() {
  const { id } = Route.useParams();
  const search = useSearch({ strict: false }) as { subTab?: string };
  return <DocumentForm id={id} subTab={search.subTab} returnUrl={RETURN_URL} />;
}
